export default __webpack_public_path__ + "images/Pizza.578360.jpg";